export const UTM = {
  SOURCE: 'utm_source',
  MEDIUM: 'utm_medium',
  CAMPAIGN: 'utm_campaign',
  TERM: 'utm_term',
  CONTENT: 'utm_content',
  FACEBOOK_ID: 'fbclid',
};

export const INTERNAL_PROMO = {
  PROMO: 'internal_promo',
  PLACEMENT: 'internal_promo_placement',
};

// Rotas de elementos internos (banners, promoções próprias do site) cujo
// link já vem com utm_source/utm_medium/utm_campaign preenchidos pelo
// Vectis — aqui esses valores viram internal_promo/internal_promo_placement
// em vez de sobrescrever a UTM de aquisição paga (ED-6914).
export const INTERNAL_PROMO_ROUTES = ['/voce-ganhou'];
